var map = {
	"./logo-aloft.png": "5cb7",
	"./logo-alux.png": "11bb",
	"./logo-ayenda.png": "1ad4",
	"./logo-guru.png": "b4d2",
	"./logo-selina.png": "909e",
	"./logo-tony.png": "bad8",
	"./logo-viajesmillenial.png": "4b0c",
	"./logo-viva.png": "e5b0",
	"./logo-yinyang.png": "f0dc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8abc";